var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.67 19.024c0 .834-.663 1.51-1.482 1.51s-1.482-.676-1.482-1.51.663-1.51 1.482-1.51 1.482.676 1.482 1.51zm-6.988 0c0 .834-.664 1.51-1.482 1.51-.819 0-1.483-.676-1.483-1.51s.664-1.51 1.483-1.51c.818 0 1.482.676 1.482 1.51zM5.32 8.117h14.187c.27 0 .436.214.367.477L18.09 15.31a.678.678 0 01-.62.476H7.912a.679.679 0 01-.62-.476L4.679 5.476A.679.679 0 004.06 5L2 5.001m4.817 8.575h11.736",
    fill: "none",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabCart);
export default __webpack_public_path__ + "static/media/ic_tab_cart.c53f6b22afa4562817ea379acc303305.svg";
export { ForwardRef as ReactComponent };